// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body
    style="padding-right: 0px; overflow: hidden;"
  >
    <div
      aria-hidden="true"
    />
    <div
      role="presentation"
      style="position: fixed; z-index: 1300; right: 0px; bottom: 0px; top: 0px; left: 0px;"
    >
      <div
        aria-hidden="true"
        style="z-index: -1; position: fixed; right: 0px; bottom: 0px; top: 0px; left: 0px; background-color: rgba(0, 0, 0, 0.5);"
      />
      <div
        data-test="sentinelStart"
        tabindex="0"
      />
      <div
        class="MuiBox-root MuiBox-root-1"
        style="outline: 0;"
        tabindex="-1"
      >
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"
        >
          <svg
            aria-hidden="true"
            class="MuiSvgIcon-root"
            focusable="false"
            style="cursor: pointer;"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </div>
        <div
          class="MuiGrid-root MuiGrid-container"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <div
              class="MuiBox-root MuiBox-root-2"
            >
              <h4
                class="MuiTypography-root MuiTypography-h4 MuiTypography-colorInherit"
              >
                Add New BCP Facility
              </h4>
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <div
              class="MuiBox-root MuiBox-root-3"
            >
              <p
                class="MuiTypography-root MuiTypography-body1"
              >
                Please ensure that you’ve enrolled in the Business Cost Premium and MSP has assigned you a facility code for your private office.
                 
                <a
                  class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
                  href="https://support.dr-bill.ca/en/articles/5274972-business-cost-premium-bcp"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Learn more.
                </a>
              </p>
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-container"
          >
            <div
              class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            >
              <div
                class="MuiBox-root MuiBox-root-4"
              >
                <div
                  class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                >
                  <label
                    class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                    data-shrink="false"
                    for="facility-code"
                    id="facility-code-label"
                  >
                    Private Office Facility Code
                    <span
                      aria-hidden="true"
                      class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                    >
                       
                      *
                    </span>
                  </label>
                  <div
                    class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                  >
                    <input
                      aria-invalid="false"
                      class="MuiInputBase-input MuiOutlinedInput-input"
                      id="facility-code"
                      maxlength="5"
                      required=""
                      type="text"
                      value=""
                    />
                    <fieldset
                      aria-hidden="true"
                      class="PrivateNotchedOutline-root-5 MuiOutlinedInput-notchedOutline"
                    >
                      <legend
                        class="PrivateNotchedOutline-legendLabelled-7"
                      >
                        <span>
                          Private Office Facility Code
                           *
                        </span>
                      </legend>
                    </fieldset>
                  </div>
                  
                </div>
              </div>
            </div>
            <div
              class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            >
              <div
                class="MuiBox-root MuiBox-root-9"
              >
                <div
                  class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                >
                  <label
                    class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                    data-shrink="false"
                    for="facility-name"
                    id="facility-name-label"
                  >
                    Private Office Name
                    <span
                      aria-hidden="true"
                      class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                    >
                       
                      *
                    </span>
                  </label>
                  <div
                    class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
                  >
                    <input
                      aria-invalid="false"
                      class="MuiInputBase-input MuiOutlinedInput-input"
                      id="facility-name"
                      required=""
                      type="text"
                      value=""
                    />
                    <fieldset
                      aria-hidden="true"
                      class="PrivateNotchedOutline-root-5 MuiOutlinedInput-notchedOutline"
                    >
                      <legend
                        class="PrivateNotchedOutline-legendLabelled-7"
                      >
                        <span>
                          Private Office Name
                           *
                        </span>
                      </legend>
                    </fieldset>
                  </div>
                  
                </div>
              </div>
            </div>
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"
            >
              <button
                class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary"
                tabindex="0"
                type="button"
              >
                <span
                  class="MuiButton-label"
                >
                  Cancel
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </button>
              <div
                class="MuiBox-root MuiBox-root-10"
              >
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled Mui-disabled"
                  disabled=""
                  tabindex="-1"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    Submit
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-test="sentinelEnd"
        tabindex="0"
      />
    </div>
  </body>,
  "container": <div
    aria-hidden="true"
  />,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
